import { t } from "@/i18n-js/instance";
import { AttachmentUploader } from "./Content/AttachmentUploader";
import { Text } from "./Content/Text";

export const ContentEditor = () => (
  <div className="px-6 py-2">
    <Text
      name="text"
      label={t("builder_ui.prop_type.text")}
      labelClassName="!font-normal text-xs"
    />
    <AttachmentUploader name="attachment" />
  </div>
);
